module.exports = __webpack_public_path__ + "static/media/green-logo-2.99956dd4.png";